import type { LocalCacheForRemoteCalendarEntry } from 'owa-graph-schema';
import { getMasterCategoryList } from 'owa-categories';
import type CategoryType from 'owa-service/lib/contract/CategoryType';
import { getCalendarEntryByFolderId } from 'owa-calendar-cache';
import type { ClientFolderId } from 'owa-client-ids';

/**
 * Returns the master category list for the given folder id. If a remote calendar, pulls
 * the categories out of the calendar cache entry for that calendar. Otherwise, uses the master category list
 * @param folderId The calendar item's parent folder id
 */
export default function getMasterCategoryListForFolder(folderId: ClientFolderId): CategoryType[] {
    if (folderId.Id) {
        let calendarEntry = getCalendarEntryByFolderId(folderId.Id);
        if (calendarEntry) {
            if ((calendarEntry as LocalCacheForRemoteCalendarEntry).RemoteCategories) {
                return (calendarEntry as LocalCacheForRemoteCalendarEntry).RemoteCategories
                    .MasterList;
            }
        }
    }

    return getMasterCategoryList(folderId.mailboxInfo);
}
